export default __webpack_public_path__ + "static/media/howwork3.5af705b0.svg";